module.exports = __webpack_public_path__ + "media/images/card_logos/mastercard-logo-95f737840dd8085be43d58eac0df7405.png";